import React from 'react'
import Cta from './cta'
import { kebabCase } from 'lodash'

export default function HoursTable({ props, includeHeading = true, multipleHours }) {
    const { heading, content, hoursDetails, menu, menuPage } = props
    const menuCta = menu ? {
        title: menu?.title,
        url: menu?.localFile?.publicURL,
        target: "_blank",
    } : null
    const menuPageCta = menuPage ? {
        title: menuPage?.diningMenu?.shortTitle || menuPage?.title,
        url: menuPage?.url,
    } : null

    const ctas = []
    if (menuPageCta) { ctas.push(menuPageCta) }
    if (menu) { ctas.push(menuCta) }

    return <div>
        {heading && includeHeading ? <h3 className="text-left font-bold mb-2 bookmark" id={kebabCase(heading)}>{heading}</h3> : null}
        {content && (
            <div
                className={`parsed-content mb-2`}
                dangerouslySetInnerHTML={{
                    __html: content,
                }}
            />
        )}
        <table className={`w-full leading-snug -mx-2 mb-3 text-sm lg:text-base ${multipleHours ? "" : ""} max-w-lg`}>
            {hoursDetails?.map(({ days, hours }, index) => {
                return (
                    <tr key={index} className="text-left odd:bg-gray-100/70">
                        <th className="font-normal px-2 py-1.5">{days}</th>
                        <td className="font-medium px-2 py-1.5">{hours}</td>
                    </tr>
                )
            }
            )}
        </table>
        {ctas?.length > 0 ?
            <nav aria-label={`${heading} menus`}>
                <ul className='flex flex-wrap'>
                    {ctas.map((cta) => {
                        return (
                            <>
                                <li key={cta.url} >
                                    {cta.url && cta.title ?
                                        <Cta props={cta} className='btn btn-primary mb-2 mr-4' />
                                        : null}
                                </li>
                            </>
                        )
                    })}
                </ul>
            </nav> : null}

    </div>
}

